import React from 'react';
import { View, StyleSheet, useWindowDimensions } from 'react-native';
import ExecutiveOverviewCard from '../../components/ExecutiveOverviewCard';
import PTExecutionSection from '../../components/PTExecutionSection';
import { PerfectTruckKpiResponse } from './perfectTruckKpiApi';

interface ExecutiveOverviewProps {
  kpiData: PerfectTruckKpiResponse | null;
  loading?: boolean;
}

const ExecutiveOverview: React.FC<ExecutiveOverviewProps> = ({ kpiData, loading = false }) => {
  const { width } = useWindowDimensions();
  const isMobileView = width < 768;
  const formatPct = (pct: number | undefined | null) =>
    pct != null ? `${Math.round(pct)}%` : '--';

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <ExecutiveOverviewCard
          title="Perfect Truck Execution"
          value={kpiData ? formatPct(kpiData.perfectTruckExecution.percentage) : '—'}
          subText={kpiData?.perfectTruckExecution.subLine ?? ''}
          infoText="Approved and declined routes divided by target routes. Crossdock and Centralized Bulk routes count once certified."
          useCompletedFormat={true}
          percentage={kpiData?.perfectTruckExecution.percentage}
          metric={kpiData?.perfectTruckExecution}
          loading={loading}
        />
        <ExecutiveOverviewCard
          title="Certifier Execution"
          value={kpiData ? formatPct(kpiData.certifierExecution.percentage) : '—'}
          subText={kpiData?.certifierExecution.subLine ?? ''}
          percentage={kpiData?.certifierExecution.percentage}
          metric={kpiData?.certifierExecution}
          loading={loading}
          containerStyle={isMobileView ? styles.mobileHalfCard : undefined}
        />
        <ExecutiveOverviewCard
          title="Checker Execution"
          value={kpiData
            ? (kpiData.checkerExecution.percentage != null
                ? formatPct(kpiData.checkerExecution.percentage)
                : kpiData.checkerExecution.subLine ?? '--')
            : '—'}
          subText={kpiData?.checkerExecution.subLine ?? ''}
          percentage={kpiData?.checkerExecution.percentage}
          metric={kpiData?.checkerExecution}
          loading={loading}
          containerStyle={isMobileView ? styles.mobileHalfCard : undefined}
        />
        <ExecutiveOverviewCard
          title="Route Outcomes"
          variant="route-outcomes"
          routeOutcomes={kpiData?.routeOutcomes}
          loading={loading}
        />
      </View>

      <PTExecutionSection trend={kpiData?.trend} breakdown={kpiData?.breakdown} loading={loading} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    rowGap: 16,
  },
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 12,
    rowGap: 12,
    alignItems: 'stretch',
  },
  mobileHalfCard: {
    minWidth: 0,
    flexBasis: '48%',
  },
});

export default ExecutiveOverview;
